export default function BeneficiariesTab({ fund, cs }) {
  return (
    <>
      {fund.mutavim?.length > 0 ? (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: cs.accent, marginBottom: 12 }}>רשימת מוטבים</div>
          <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 8 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, textAlign: "right" }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: `2px solid ${cs.border}`, color: cs.dark }}>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>שם מוטב / חלוקה</th>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>אחוז (%)</th>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>מספר זיהוי</th>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>זיקה</th>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>תאריך לידה</th>
                  <th style={{ padding: "10px 12px", fontWeight: 700 }}>הגדרה</th>
                </tr>
              </thead>
              <tbody>
                {fund.mutavim.map((m, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #e2e8f0", background: i % 2 === 0 ? "white" : "#f8fafc" }}>
                    <td style={{ padding: "9px 12px", fontWeight: 600 }}>{m.displayName}</td>
                    <td style={{ padding: "9px 12px" }}>{m.pct ? `${m.pct}%` : "—"}</td>
                    <td style={{ padding: "9px 12px" }}>{m.id || "—"}</td>
                    <td style={{ padding: "9px 12px" }}>{m.zika || "—"}</td>
                    <td style={{ padding: "9px 12px" }}>{m.bday || "—"}</td>
                    <td style={{ padding: "9px 12px" }}>{m.hagdara || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div style={{ color: "#94a3b8", fontSize: 13 }}>לא הוגדר מוטב</div>
      )}
    </>
  );
}
